import React from 'react';

/*
    - ihoDesignSystem
*/
import { Badge, Box, Button, Checkbox, Grid, Image, Modal, Typography } from '@iho-design-system/Loader';

/*
    - icon
*/
import ObserverSVG from '../../../assets/images/icons/observer.svg';
import EmptySVG from '../../../assets/images/icons/empty.svg';
import PaginationRightSVG from '../../../assets/images/icons/pagination-right.svg';
import PaginationLeftSVG from '../../../assets/images/icons/pagination-left.svg';
import TrashBinSVG from '../../../assets/images/icons/trashbin-white.svg';
import LoadingCustomSVG from '../../../assets/images/icons/loading-custom.svg';

/*
    - api
*/
import editMembersStatusAPI from '../../../api/edit/MembersStatus';

const List = ({ props, alertProps, reloadUserProps, paginationProps }) => {

    /*
       - defaultData
    */
    const [membersResult, setMembersResult] = React.useState('loading');
    const [memberDetail, setMemberDetail] = React.useState('');
    const [selectedMember, setSelectedMember] = React.useState({});

    React.useEffect(() => {
        if (props.members !== '') {
            if (props.members.status === 200 && props.members.data.Data.length > 0) {
                setMembersResult(props.members.data);
            } else {
                setMembersResult('empty');
            }
        }
    }, [props]);

    /*
        - selectedMemberHandler
    */
    const selectedMemberHandler = (obj, status) => {
        setSelectedMember(prev => ({ ...prev, [obj.UserId]: status }));
    }

    React.useEffect(() => {
        let keys = Object.keys(selectedMember);
        keys.forEach((obj) => {
            if (selectedMember[obj] === true) {
                document.querySelector(`.list${obj}`).style.backgroundColor = 'var(--blue-ultra-light)';
            } else {
                document.querySelector(`.list${obj}`).style.backgroundColor = 'var(--white)';
            }
        });
    }, [selectedMember]);


    /*
        - editMemberStatus
    */
    const editMemberStatus = async (status) => {
        let keys = Object.keys(selectedMember);
        let selectedMemeberId = [];
        keys.forEach((obj) => {
            if (selectedMember[obj] === true) {
                selectedMemeberId.push(obj)
            }
        });
        if (selectedMemeberId.length === 0) {
            alertProps(['danger', ' عضوی انتخاب نشده است']);
            return false;
        }
        let parameters = {
            UserIds: '',
            Status: status
        };
        parameters.UserIds = selectedMemeberId;
        let result = await editMembersStatusAPI(parameters);
        if (result === 'success') {
            alertProps(['success', 'با موفقیت انجام شد']);
            reloadUserProps(Math.floor(Math.random() * 100));
            setSelectedMember({});
        } else {
            alertProps(['danger', 'خطایی رخ داده است']);
        }
        document.querySelectorAll('input[type=checkbox]').forEach((obj) => {
            obj.checked = false;
        });
    }

    /*
        - modal
    */
    const openModal = (modal, value) => {
        setMemberDetail(value);
        document.querySelector(`.${modal}`).classList.remove('d-none');
    }

    if (membersResult === 'loading') {
        return (
            <Image
                className={`d-block mx-auto`}
                src={LoadingCustomSVG}
                ms={{
                    width: '40px',
                    height: '40px'
                }} />
        );
    }

    if (membersResult === 'empty') {
        return (
            <React.Fragment>
                <Box>
                    <Image
                        className={`mx-auto`}
                        src={EmptySVG}
                        ms={{
                            display: 'block',
                            width: '120px',
                            height: '120px'
                        }} />
                    <Typography
                        className={`d-block text-center`}
                        component='h2'>
                        لیست اعضای شما خالی است :(
                    </Typography>
                    <Box
                        className={`my-md`} />
                    <Typography
                        className={`d-block text-center`}
                        component='strong'>
                        تاکنون هیچ عضوی را ثبت نکرده اید!
                    </Typography>
                </Box>
            </React.Fragment>
        );
    }

    if (membersResult !== 'empty') {
        return (
            <React.Fragment>
                <Grid>
                    <Grid.Wrapper>
                        <Grid.Item
                            size='col-12'>
                            <Box
                                ms={{
                                    '@media(max-width:992px)': {
                                        overflowX: 'scroll'
                                    }
                                }}>
                                <Box
                                    ms={{
                                        minWidth: '992px'
                                    }}>
                                    <Box
                                        className={`d-inline-block w-100 my-sm mt-0 px-xl py-lg rounded-sm`}
                                        ms={{
                                            backgroundColor: 'var(--gray-light)'
                                        }}>
                                        <Box
                                            className={`d-inline-block`}
                                            ms={{
                                                width: '20.6666%'
                                            }}>
                                            <Typography>
                                                نام و نام خانوادگی
                                            </Typography>
                                        </Box>
                                        <Box
                                            className={`d-inline-block`}
                                            ms={{
                                                width: '16.6666%'
                                            }}>
                                            <Typography>
                                                شماره ملی(پاسپورت)
                                            </Typography>
                                        </Box>
                                        <Box
                                            className={`d-inline-block`}
                                            ms={{
                                                width: '16.6666%'
                                            }}>
                                            <Typography>
                                                سطح کاربری
                                            </Typography>
                                        </Box>
                                        <Box
                                            className={`d-inline-block`}
                                            ms={{
                                                width: '22.6666%'
                                            }}>
                                            <Typography>
                                                شارژ غیر قابل تسویه(تومان)
                                            </Typography>
                                        </Box>
                                        <Box
                                            className={`d-inline-block`}
                                            ms={{
                                                width: '16.6666%'
                                            }}>
                                            <Typography>
                                                شارژ باقیمانده (تومان)
                                            </Typography>
                                        </Box>
                                        <Box
                                            className={`d-inline-block`}
                                            ms={{
                                                width: '6.6666%'
                                            }} />
                                    </Box>
                                    <Box
                                        className={`border-solid border-light rounded-sm`}
                                        ms={{
                                            backgroundColor: 'var(--white)'
                                        }}>
                                        {membersResult.Data.map((obj, index) => {
                                            return (
                                                <Box
                                                    key={index}>
                                                    <Box
                                                        className={`list${obj.UserId} d-flex justify-content-between px-lg py-md border-solid-bottom border-light`}>
                                                        <Box
                                                            ms={{
                                                                width: '20.6666%'
                                                            }}>
                                                            <Checkbox
                                                                onChange={(status) => selectedMemberHandler(obj, status)}
                                                                label={obj.FullName}
                                                                ms={{
                                                                    verticalAlign: 'middle'
                                                                }} />
                                                            {obj.Status === 1 &&
                                                                <Badge>
                                                                    جدید
                                                                </Badge>
                                                            }
                                                        </Box>
                                                        <Box
                                                            ms={{
                                                                width: '16.6666%'
                                                            }}>
                                                            {obj.NationalCode}
                                                        </Box>
                                                        <Box
                                                            ms={{
                                                                width: '16.6666%'
                                                            }}>
                                                            {obj.JobTitle !== null ? obj.JobTitle : 'تعریف نشده'}
                                                        </Box>
                                                        <Box
                                                            ms={{
                                                                width: '22.6666%'
                                                            }}>
                                                            {(Math.floor(obj.WholeCharge) / 10).toLocaleString()} تومان
                                                        </Box>
                                                        <Box
                                                            ms={{
                                                                width: '16.6666%'
                                                            }}>
                                                            {(Math.floor(obj.RemainCharge) / 10).toLocaleString()} تومان
                                                        </Box>
                                                        <Box
                                                            className={`d-flex align-item-center justify-content-end`}
                                                            ms={{
                                                                width: '6.6666%'
                                                            }}>
                                                            <Image
                                                                className={`pointer`}
                                                                onClick={() => openModal('memberDetailModal', obj)}
                                                                src={ObserverSVG}
                                                                ms={{
                                                                    width: '16px',
                                                                    height: '16px'
                                                                }} />
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            );
                                        })}
                                        <Box
                                            className={`d-flex justify-content-between rounded-sm rounded-top-right-0 rounded-top-left-0`}
                                            ms={{
                                                height: '56px',
                                                backgroundColor: 'var(--gray-ultra-light)'
                                            }}>
                                            <Box
                                                className={`d-flex align-self-center`}
                                                ms={{
                                                    width: '33.3333%',
                                                    gap: 'var(--sizing-sm)'
                                                }}>
                                                <Button
                                                    color='primary'
                                                    onClick={() => editMemberStatus(2)}>
                                                    تایید
                                                </Button>
                                                <Button
                                                    onClick={() => editMemberStatus(3)}
                                                    className={`d-flex align-item-center`}
                                                    color='danger'>
                                                    <Image
                                                        src={TrashBinSVG} />
                                                    حذف
                                                </Button>
                                            </Box>
                                            <Box
                                                className={`d-flex justify-content-center align-item-center`}
                                                ms={{
                                                    width: '33.3333%',
                                                    gap: '16px'
                                                }}>
                                                <Button
                                                    onClick={() => paginationProps(-1)}
                                                    className={`p-0 rounded-lg`}
                                                    variant='outlined'
                                                    color='primary'
                                                    ms={{
                                                        width: '30px !important',
                                                        height: '30px !important',
                                                        backgroundColor: 'var(--white) !important',
                                                        borderColor: 'var(--white) !important',
                                                        boxShadow: 'var(--shadow-dark)'
                                                    }}>
                                                    <Image
                                                        src={PaginationRightSVG} />
                                                </Button>
                                                <Typography
                                                    className={`text-primary`}>
                                                    {membersResult.PageIndex} / {Math.ceil(membersResult.TotalItems / membersResult.PageSize)}
                                                </Typography>
                                                <Button
                                                    onClick={() => paginationProps(1)}
                                                    className={`p-0 rounded-lg`}
                                                    variant='outlined'
                                                    color='primary'
                                                    ms={{
                                                        width: '30px !important',
                                                        height: '30px !important',
                                                        backgroundColor: 'var(--white) !important',
                                                        borderColor: 'var(--white) !important',
                                                        boxShadow: 'var(--shadow-dark)'
                                                    }}>
                                                    <Image
                                                        src={PaginationLeftSVG} />
                                                </Button>
                                            </Box>
                                            <Box
                                                ms={{
                                                    width: '33.3333%'
                                                }} />
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Grid.Item>
                    </Grid.Wrapper>
                </Grid>
                <Modal
                    className={`memberDetailModal`}>
                    <Modal.Wrapper
                        size='xs'
                        ms={{
                            '@media(max-width:576px)': {
                                width: '100% !important'
                            }
                        }}>
                        <Modal.Header
                            className={`my-md mt-0 border-solid-bottom border-light`}>
                            اطلاعات بیشتر
                            <Box />
                        </Modal.Header>
                        <Box
                            className={`p-sm`}
                            component='form'>
                            <Grid>
                                <Grid.Wrapper>
                                    <Grid.Item
                                        size='col-6'>
                                        <Typography
                                            className={`d-block text-bold`}>
                                            نام و نام خانوادگی
                                        </Typography>
                                        {memberDetail.FullName}
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-6'>
                                        <Typography
                                            className={`d-block text-bold`}>
                                            شماره ملی(پاسپورت)
                                        </Typography>
                                        {memberDetail.NationalCode}
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-6'>
                                        <Typography
                                            className={`d-block text-bold`}>
                                            سطح کاربری
                                        </Typography>
                                        {memberDetail.JobTitle !== null ? memberDetail.JobTitle : 'تعریف نشده'}
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-6'>
                                        <Typography
                                            className={`d-block text-bold`}>
                                            کد سازمانی
                                        </Typography>
                                        {memberDetail.OrganizationCode !== null ? memberDetail.OrganizationCode : 'تعریف نشده'}
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-6'>
                                        <Typography
                                            className={`d-block text-bold`}>
                                            شارژ غیر قابل تسویه
                                        </Typography>
                                        {(Math.floor(memberDetail.WholeCharge) / 10).toLocaleString()} تومان
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-6'>
                                        <Typography
                                            className={`d-block text-bold`}>
                                            شارژ باقیمانده
                                        </Typography>
                                        {(Math.floor(memberDetail.RemainCharge) / 10).toLocaleString()} تومان
                                    </Grid.Item>
                                </Grid.Wrapper>
                            </Grid>
                        </Box>
                    </Modal.Wrapper>
                </Modal>
            </React.Fragment >
        );
    }

}

export default List;